'use client';

import { useShop } from '@/i18n/client';
import { metaTrack } from '@/lib/meta-client';
import { useCart } from './CartProvider';

type Props = { sku: string; offer?: string; className?: string; children?: React.ReactNode; label?: string };

// Adds the product in the given offer (its default offer when none is given) and opens the
// right-hand cart drawer so the shopper can review the order before checking out.
export function AddToCart({ sku, offer, className = 'btn', children, label }: Props) {
  const { add, setOpen } = useCart();
  const { addToCart, currency } = useShop();
  return (
    <button className={className} type="button" data-track="add-to-cart" aria-label={label} aria-controls="cart" aria-haspopup="dialog" onClick={() => { add(sku, offer); metaTrack('AddToCart', [{ sku, offer, qty: 1 }], currency); setOpen(true); }}>
      {children ?? addToCart}
    </button>
  );
}
